<template>
  <SiteEmptyState
    eyebrow="Error 404"
    title="Page not found"
    description="The page may have moved, or the address may be incorrect. Return home or contact us if you need help finding something."
    icon="pi pi-compass"
    heading-tag="h1"
  >
    <template #actions>
      <Button
        rounded
        label="Return home"
        icon="pi pi-home"
        class="w-full sm:w-auto"
        @click="navigateFromNotFound('/')"
      />
      <Button
        outlined
        rounded
        label="Contact us"
        icon="pi pi-envelope"
        class="w-full sm:w-auto"
        @click="navigateFromNotFound('/contact-us')"
      />
    </template>
  </SiteEmptyState>
</template>

<script setup>
const activeError = useError()
const requestEvent = useRequestEvent()

if (requestEvent) {
  setResponseStatus(requestEvent, 404, 'Page Not Found')
}

useSeoMeta({
  title: 'Page not found | SATS',
  description: 'The page you requested could not be found.',
  robots: 'noindex, nofollow',
})

const navigateFromNotFound = async (path) => {
  if (activeError.value) {
    await clearError({ redirect: path })
    return
  }

  await navigateTo(path)
}
</script>
